import { render, staticRenderFns } from "./GoogleSuburbAutocomplete.vue?vue&type=template&id=9502515e"
import script from "./GoogleSuburbAutocomplete.vue?vue&type=script&lang=js"
export * from "./GoogleSuburbAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9502515e')) {
      api.createRecord('9502515e', component.options)
    } else {
      api.reload('9502515e', component.options)
    }
    module.hot.accept("./GoogleSuburbAutocomplete.vue?vue&type=template&id=9502515e", function () {
      api.rerender('9502515e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Address/GoogleSuburbAutocomplete.vue"
export default component.exports